/**
 * AccountInsightsBar — Use Cases 页 · Account 视图上方的行业级资源分配洞察栏。
 *
 * 移植自 v3 prototype 的 account-mode insights 渲染（app.html，acctData.insights）。
 * 纯展示，无交互：把 GetAccountCrossUc 返回的 AccountInsights 渲染成一个标题 +
 * 三条件 callout（高价值低介入 / 投入过度 / 高价值停滞）。
 *
 * 三个 callout 仅在对应数组非空时渲染（对齐 prototype 的条件渲染）。账户名经
 * slice(0,15) 截断后用 textContent 渲染（React 默认转义，无 XSS 风险）。
 */

import type { AccountInsights } from '../../../utils/accountInsights';

export default function AccountInsightsBar({
  industry,
  insights,
}: {
  industry: string;
  insights: AccountInsights;
}) {
  const highArr = insights.highArrLowInfluence ?? [];
  const overInv = insights.overInvested ?? [];
  const stale = insights.staleHighValue ?? [];

  return (
    <div className="ivt-acct-insights">
      <div className="ivt-acct-insights__head">
        📋 {industry} 资源分配洞察 · {insights.totalAccounts ?? 0} accounts ·{' '}
        {insights.healthyCount ?? 0} 个健康推进
      </div>

      {highArr.length > 0 && (
        <div className="ivt-acct-insights__callout ivt-acct-insights__callout--amber">
          💡 <b>高价值低介入</b>：
          {highArr.map((a, i) => (
            <span key={i} className="ivt-acct-insights__item">
              {(a.name ?? '').slice(0, 15)} ${((a.arr ?? 0) / 1e6).toFixed(1)}M
            </span>
          ))}
        </div>
      )}

      {overInv.length > 0 && (
        <div className="ivt-acct-insights__callout ivt-acct-insights__callout--red">
          ⚠️ <b>投入过度</b>：
          {overInv.map((a, i) => (
            <span key={i} className="ivt-acct-insights__item">
              {(a.name ?? '').slice(0, 15)} ${((a.arr ?? 0) / 1e3).toFixed(0)}K
            </span>
          ))}
        </div>
      )}

      {stale.length > 0 && (
        <div className="ivt-acct-insights__callout ivt-acct-insights__callout--red">
          🔴 <b>高价值停滞</b>（ARR≥$100K 无活动）：
          {stale.map((a, i) => (
            <span key={i} className="ivt-acct-insights__item">
              {(a.name ?? '').slice(0, 15)} ${((a.arr ?? 0) / 1e3).toFixed(0)}K
            </span>
          ))}
        </div>
      )}
    </div>
  );
}
